<template>
  <div class="organizations-list">
    <h1 class="page-header" v-if="category.name">{{ category.name }}</h1>
    <div v-if="showResults">
      <search-box
        :query="searchQuery"
        @input="onSearchInput"
        @search="performSearch"
        input-class="form-control py-5 mb-5 search-box border-primary shadow-dark"
        placeholder="Type an organization name or category"
        aria-label="Type an organization name or category"
        aria-describedby="searchAddon"
        :is-search-stalled="isLoading"
      />
      
      <categories />
      
      <div
        v-if="
          category.organization &&
          category.organization[this.$store.state.country + '_code'] > 0 &&
          category.organization.active
        "
        class="mt-6"
      >
        <organization-card :item="category.organization" />
      </div>
      
      <search-results :hits="searchResults.hits" :is-loading="isLoading">
        <template v-slot="{ items }">
          <div class="container">
            <div class="row mt-6">
              <organization-card
                :item="item"
                v-for="item in items"
                :key="item.id"
              />
            </div>
          </div>
        </template>
        <template v-slot:no-results>
          <p class="text-center">No projects in this category</p>
        </template>
      </search-results>
      
      <div class="container">
        <pagination
          :current-page="searchResults.currentPage"
          :total-pages="searchResults.totalPages"
          @page-change="onPageChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
import SearchService from "../services/searchService";
import SearchBox from "../components/SearchBox";
import SearchResults from "../components/SearchResults";
import Pagination from "../components/Pagination";
import OrganizationCard from "../components/OrganizationCard";
import Categories from "../components/Categories";

export default {
  name: "Projects",
  metaInfo() {
    return {
      title: this.title,
    };
  },

  components: {
    SearchBox,
    SearchResults,
    Pagination,
    OrganizationCard,
    Categories,
  },
  
  data() {
    return {
      title: "",
      showResults: true,
      filters: "",
      organizationId: null,
      category: {
        id: null,
        name: null,
      },
      searchQuery: "",
      searchResults: {
        hits: [],
        totalHits: 0,
        currentPage: 0,
        totalPages: 0,
      },
      isLoading: false,
      searchDebounce: null,
    };
  },
  
  mounted() {
    this.updateList();
  },
  
  watch: {
    "$store.state.country": function () {
      this.updateList();
    },
    $route(to, from) {
      this.updateList();
    },
  },
  
  methods: {
    async performSearch(query = this.searchQuery, page = 0) {
      this.isLoading = true;
      
      try {
        const limit = 24;
        const offset = page * limit;
        
        const results = await SearchService.search(query, {
          filter: this.filters,
          limit,
          offset,
        });
        
        this.searchResults = results;
      } catch (error) {
        console.error('Search failed:', error);
        this.searchResults = {
          hits: [],
          totalHits: 0,
          currentPage: 0,
          totalPages: 0,
        };
      } finally {
        this.isLoading = false;
      }
    },
    
    onSearchInput(query) {
      this.searchQuery = query;
      
      // Debounce search
      if (this.searchDebounce) {
        clearTimeout(this.searchDebounce);
      }
      
      this.searchDebounce = setTimeout(() => {
        this.performSearch(query, 0);
      }, 300);
    },
    
    onPageChange(page) {
      this.performSearch(this.searchQuery, page);
      this.$nextTick(function () {
        window.scrollTo({
          top: document.querySelector(".organizations-list").offsetTop - 60,
          left: 0,
          behavior: "smooth",
        });
      });
    },
    
    updateList() {
      if (this.$route.query.category > 0) {
        this.getCategory(this.$route.query.category);
        this.showResults = false;
        this.$nextTick(function () {
          this.filters =
            this.$store.state.country +
            "_code > 0 AND active:true" +
            " AND organization_category_id:" +
            this.$route.query.category;
          this.$nextTick(function () {
            this.showResults = true;
            this.performSearch();
          });
        });
      } else {
        this.title = "Projects";
        this.showResults = false;
        this.category.name = null;
        this.$nextTick(function () {
          this.filters =
            this.$store.state.country + "_code > 0 AND active:true";
        });
        this.$nextTick(function () {
          this.showResults = true;
          this.performSearch();
        });
      }
    },
    
    getCategory(id) {
      let self = this;
      this.axios
        .get(window.API_URL + "categories/" + id)
        .then(function (response) {
          self.category.id = response.data.id;
          self.category.name = response.data.name;
          self.title = response.data.name;
          self.category.organization = response.data.organization;
        })
        .catch(function (error) {});
    },
  },
};
</script>
<style lang="scss">
.search-box {
  border-radius: 30px;
}
</style>